import React, {Component} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {Table} from 'reactstrap';
import {toast} from 'react-toastify';
import Switch from "react-switch";

import ErrorMsg from "../common/ErrorMsg";
import UserActivityModal from "./UserActivityModal";


export default class ActivityLog extends Component {
    state = {
        activityLogList: [],
        openUserActivityModal: false,
        selectedLog: {},
        isLoading: false,
        totalPage: 0,
        currentPage: 1,
        nextPageNo: null,
        prevPageNo: null,
        allLocationFilter: 1,
    }

    componentDidMount = () => {
        if (this.props.agencyLocation) {
            this.getInitialState();
        }
    };

    getInitialState = async () => {
        try {
            let {allLocationFilter, currentPage} = this.state;
            const {agencyLocation, locationList} = this.props;
            if (locationList.length > 1 && allLocationFilter) {
                allLocationFilter = 1;
            } else {
                allLocationFilter = 0;
            }
            let result = await this.props.getActivityLogList(
                agencyLocation, currentPage, allLocationFilter
            );
            if(result) {
                let totalPage = Math.ceil(result.count / result.page_size)
                let activityLogList = result.logs.map(log => ({...log}));
                this.setState({
                    activityLogList, totalPage,
                    currentPage: result.page,
                    nextPageNo: result.next,
                    prevPageNo: result.previous
                });
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>);
        }
    };

    toggleAllLocationFilter = () => {
		this.setState((prevState) => ({
			allLocationFilter: prevState.allLocationFilter ? 0 : 1
        }), () => {this.getInitialState()});
    }

    getPageData = (page=1) => {
        this.setState({currentPage: page}, () => this.getInitialState());
    }

    toggleModal = () => {
        this.setState({activityLogList: []});
        this.props.toggleModal();
    }

    openUserActivityModal = (selectedLog) => {
        let activityLogList = this.state.activityLogList.map(log => {
            let currentLog = {...log};
            if (selectedLog.id === currentLog.id) {
                currentLog['is_selected'] = true;
            } else {
                currentLog['is_selected'] = false;
            }
            return currentLog;
        });
        this.setState({selectedLog, openUserActivityModal: true, activityLogList});
    }

    toggleUserActivityModal = () => {
        this.setState(prevState => ({
            openUserActivityModal: !prevState.openUserActivityModal
        }));
    }

    render() {
        const {
            activityLogList, openUserActivityModal, selectedLog,
            totalPage, nextPageNo, prevPageNo, currentPage, allLocationFilter
        } = this.state;
        const {locationList} = this.props;

        let tableRows = activityLogList.map((log, index) => {
            return (
                <tr key={index} className={log.is_selected ? 
                        "cursor-pointer bg-info text-white" : "cursor-pointer"} 
                    onClick={() => this.openUserActivityModal(log)}
                >
                    <td className="align-middle">{log.created_at}</td>
                    {locationList.length > 1 && 
                        <td className="align-middle">
                            {log.location_name}
                        </td>
                    }
                    <td className="align-middle">{log.file_id}</td>
                    <td className="align-middle">{log.file_name}</td>
                    <td className="text-center align-middle">{log.no_of_records}</td>
                    <td className="align-middle ellipsis-td" title={log.status}>
                        {log.status}
                    </td>
                </tr>
            );
        });
        return (
            <Modal isOpen={this.props.modal} toggle={this.toggleModal} size="lg">
                <ModalHeader toggle={this.toggleModal}>
                    Activity Log
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-12">
                            <Table responsive striped bordered hover={false} size="sm" 
                                className="mb-0 bg-white"
                            >
                                <thead className="bg-f5">
                                    <tr>
                                        <th className="font-weight-bold" 
                                            style={{width:"165px"}}>Date & Time
                                        </th>
                                        {locationList.length > 1 &&
                                            <th className="font-weight-bold"
                                                style={{width: "125px"}}
                                            >
                                                Location
                                                <br/>
                                                <label className="mb-0 font-13">
                                                    <Switch 
                                                        onChange={this.toggleAllLocationFilter} 
                                                        checked={Boolean(allLocationFilter)} 
                                                        className="react-switch"
                                                        name="all_location"
                                                        height={17}
                                                        width={36}
                                                    />
                                                    <span>All</span>
                                                </label>
                                            </th>
                                        }
                                        <th className="font-weight-bold">
                                            File ID
                                        </th>
                                        <th className="font-weight-bold">
                                            File Name
                                        </th>
                                        <th className="font-weight-bold text-center">
                                            No of Records<br/> Imported
                                        </th>
                                        <th className="font-weight-bold">
                                            Status
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="font-14">
                                    <tr></tr>
                                    {tableRows}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter className="justify-content-between align-items-center">
                    {activityLogList.length > 0 &&
                        <nav aria-label="...">
                            <ul className="pagination pagination-sm">
                                {prevPageNo && <React.Fragment>
                                    <li className="page-item" onClick={() => 
                                        this.getPageData(1)}
                                    >
                                        <a className="page-link" href="javascript:">
                                            First
                                        </a>
                                    </li>
                                    <li className="page-item" onClick={() => 
                                        this.getPageData(prevPageNo)}
                                    >
                                        <a className="page-link" href="javascript:">
                                            {'<<'}
                                        </a>
                                    </li>
                                </React.Fragment>}
                                <li className="page-item active">
                                    <a className="page-link" href="javascript:">
                                        {currentPage} of {totalPage}
                                    </a>
                                </li>
                                {nextPageNo && <React.Fragment>
                                    <li className="page-item" onClick={() => 
                                        this.getPageData(nextPageNo)}
                                    >
                                        <a className="page-link" href="javascript:">
                                            {'>>'}
                                        </a>
                                    </li>
                                    <li className="page-item" onClick={() => 
                                        this.getPageData(totalPage)}
                                    >
                                        <a className="page-link" href="javascript:">
                                            Last
                                        </a>
                                    </li>
                                </React.Fragment>}
                            </ul>
                        </nav>
                    }
                    <Button className='btn btn-secondary btn-sm' onClick={this.toggleModal}>
                        Close
                    </Button>
                </ModalFooter>
                {openUserActivityModal && 
                    <UserActivityModal {...this.props} 
                        modal={openUserActivityModal} 
                        toggleModal={this.toggleUserActivityModal} 
                        selectedLog={selectedLog} 
                    />
                }
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/adminHome/ActivityLog.js